module.exports = __webpack_public_path__ + "media/images/cbs_logo-2e1f8c234fe95e3375328ec7912c7cec.png";